<template>
    <div class="center-page">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="系统消息" name="system"></el-tab-pane>
            <el-tab-pane label="订单通知" name="order"></el-tab-pane>
            <!--<el-tab-pane label="聊天消息" name="socketSelect"></el-tab-pane>-->
        </el-tabs>
        <div v-if="activeName!=='socketSelect'" v-loading="loading" class="list-content">
            <div v-for="item in msgList" class="list-item" :key="item.id">
                <div class="list-item-title">
                    {{item.data.title}}
                    <span class="f-14 color-grays">{{item.updated_at}}</span>
                </div>
                <div class="list-item-text">{{item.data.content}}</div>
            </div>
            <el-alert v-if="msgList.length<=0" title="暂无数据~" center :closable="false" type="warning" show-icon></el-alert>
        </div>
        <div v-else v-loading="loading" class="list-content">
            <div v-for="item in chartList" class="list-item" :key="item.id">
                <div class="list-item-title">
                    {{item.user_name}}
                    <span class="f-14 color-grays">{{item.updated_at}}</span>
                </div>
                <div class="list-item-text">{{item.content}}</div>
            </div>
            <el-alert v-if="msgList.length<=0" title="暂无数据~" center :closable="false" type="warning" show-icon></el-alert>
        </div>
        <div class="list-content" v-loading="loading" v-else>
            <el-alert v-if="chartList.length<=0" title="暂无数据~" center :closable="false" type="warning" show-icon></el-alert>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "msgCenter",
        data() {
            return {
                loading: false,
                activeName: 'system',
                page: 1,
                pageSize: 10,
                msgList: [],
                chartList: []
            }
        },
        created() {
            this.userMessage();
        },
        computed:{
            ...mapState(['userInfo']),
        },
        methods: {
            async userMessage() {
                this.loading = true;
                let [e, data] = await this.$api.userMessageApi({
                    mark: this.activeName,
                    page: this.page,
                    size: this.pageSize
                });
                this.loading = false;
                this.msgList = data.result;
            },
            async socketSelect(){
                this.loading = true;
                let [e, data] = await this.$api.socketSelectApi();
                this.loading = false;
                this.chartList = data.result;
            },
            handleClick(tab){
                if(tab.name !== 'socketSelect'){
                    this.page = 1;
                    this.userMessage();
                }else{
                    this.socketSelect()
                }
            }
        },
    }
</script>

<style scoped lang="less">
    .list-content{
        padding: 10px 0;
        box-sizing: border-box;
        width: 100%;
        .list-item{
            width: 100%;
            height: 80px;
            margin-bottom: 20px;
            border-radius: 8px;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            padding-left: 80px;
            padding-right: 30px;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            flex-flow: column;
            cursor: pointer;
            &:hover{
                background-color: rgba(228, 70, 70, 0.1);
            }
        }
        .list-item-title{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 16px;
            font-weight: bold;
        }
        .list-item-text{
            font-size: 14px;
            color: #949494;
            margin-top: 6px;
        }
    }
</style>
